const flattenMarks = (editor: CKEDITOR.editor) => {
  editor
    .editable()
    .$.querySelectorAll('mark')
    .forEach((mark) => {
      if (!mark.children.length) {
        return
      }

      const parentNode = mark.parentNode

      if (!parentNode) {
        return
      }

      Array.from(mark.childNodes).forEach((child) => {
        const childEl =
          child.nodeType === Node.ELEMENT_NODE ? (child as Element) : null

        if (childEl && ['SPAN'].includes(childEl.tagName)) {
          const innerMark = document.createElement('mark')

          while (child.firstChild) {
            innerMark.appendChild(child.firstChild)
          }

          child.appendChild(innerMark)
          parentNode.insertBefore(child, mark)
        } else {
          let newMark =
            mark.previousElementSibling?.tagName === 'MARK'
              ? mark.previousElementSibling
              : null

          if (!newMark) {
            newMark = document.createElement('mark')

            parentNode.insertBefore(newMark, mark)
          }

          newMark.appendChild(child)
        }
      })

      mark.remove()
    })
}

export const textHighlightPlugin: CKEDITOR.pluginDefinition = {
  init: (editor) => {
    const highlightStyle = new CKEDITOR.style(
      {
        element: 'mark',
      },
      undefined
    )

    const removeFormatTagsList = new Set(
      editor.config.removeFormatTags?.split(',')
    )

    editor.config.removeFormatTags = ''

    removeFormatTagsList.add('mark')

    removeFormatTagsList.forEach((tagName) => {
      if (editor.config.removeFormatTags) {
        editor.config.removeFormatTags += ','
      }

      editor.config.removeFormatTags += tagName
    })

    editor.addCommand('highlight', {
      exec: (editor) => {
        if (highlightStyle.checkActive(editor.elementPath(), editor)) {
          editor.removeStyle(highlightStyle)
        } else {
          editor.applyStyle(highlightStyle)
          flattenMarks(editor)
        }

        const ranges = editor.getSelection().getRanges()

        if (ranges.length) {
          const lastRange = ranges[ranges.length - 1]

          lastRange.collapse(false)
          editor.getSelection().selectRanges([lastRange])
        }

        return false
      },
    })

    editor.attachStyleStateChange(highlightStyle, (state) => {
      editor
        .getCommand('highlight')
        .setState(
          state === CKEDITOR.TRISTATE_ON
            ? CKEDITOR.TRISTATE_ON
            : CKEDITOR.TRISTATE_OFF
        )
    })

    editor.ui.addButton('Highlight', {
      label: 'Выделить текст цветом',
      command: 'highlight',
      toolbar: 'basicstyles',
    })

    editor.addFeature({
      allowedContent: 'mark',
      requiredContent: 'mark',
    })
  },
}
